import cookies from 'js-cookie'
import { decorateFetch } from '../../../../../api'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import {
  Dependency,
  DependencyTreeResult,
  ModulesResponse,
  ReportCli,
  ReportList
} from '../interfaces'

export const getData = async <T>(url: string): Promise<T> => {
  let res
  try {
    const decoratedFetch = decorateFetch(
      fetch,
      cookies,
      document.location,
      window.localStorage
    )

    res = await decoratedFetch(url, {
      method: 'GET'
    })
  } catch {
    throw Error('could not fetch the data for that resource')
  }

  return res.json()
}

export const GetDependencyTreeReports = (
  applicationId: string,
  organizationID: string,
  enabled: boolean
) => {
  const url = `/Contrast/api/ng/sca/organizations/${organizationID}/applications/${applicationId}/reports/list`

  return useContrastQuery(
    ['depTreeReportData', url],
    () => getData<ReportList>(url),
    url,
    { enabled }
  )
}

export const GetCliDependencyTreeReports = (
  applicationId: string,
  organizationID: string
) => {
  const url = `/Contrast/api/sca/organizations/${organizationID}/applications/${applicationId}/libraries/tree/reports`

  return useContrastQuery(
    ['depTreeReportDataCLI', url],
    () => getData<ReportCli[]>(url),
    url
  )
}

export const GetDependencyTreeData = (
  applicationId: string | undefined,
  organizationID: string,
  reportId: string | undefined,
  libraryFilter: string,
  enabled: boolean
) => {
  const url = `/Contrast/api/ng/sca/organizations/${organizationID}/applications/${applicationId}/reports/${reportId}?nodesToInclude=${libraryFilter}`

  return useContrastQuery(
    ['depTreeViewData', url],
    () => getData<DependencyTreeResult>(url),
    url,
    {
      enabled
    }
  )
}

export const GetCliDependencyTreeData = (
  applicationId: string | undefined,
  organizationID: string,
  reportId: string | undefined,
  libraryFilter: string,
  enabled: boolean
) => {
  const nodesToInclude =
    libraryFilter === 'ALL' ? '' : `?nodesToInclude=${libraryFilter}`

  const url = `/Contrast/api/sca/organizations/${organizationID}/applications/${applicationId}/libraries/tree/${reportId}${nodesToInclude}`

  return useContrastQuery(
    ['depTreeViewDataCli', url],
    () => getData<Dependency[]>(url),
    url,
    {
      enabled
    }
  )
}

export const GetMergedApplications = (
  applicationId: string | undefined,
  organizationID: string
) => {
  const url = `/Contrast/api/ng/${organizationID}/modules/${applicationId}`

  return useContrastQuery(
    ['getMergedApplications', url],
    () => getData<ModulesResponse>(url),
    url
  )
}
